import React, {useCallback, useEffect, useMemo, useState} from "react";
import {set, isEmpty} from "lodash";
import {ConfigProvider} from "antd";
import {useRequest} from "../../utils/hooks.jsx";
import {NOOP} from "../../utils/NOOP.jsx";
import {FormModal} from "../../components/index.jsx";
import {briefModalDescription} from "./consts.js";
import "./brief-form-modal.css";
import {buildBriefFormFields} from "./utils.jsx";
import {BriefMainServices} from "../../consts.js";
import {kosherTypesToHebrew} from "../../marketplace/ProductsFilterModal/consts.jsx";

export const BriefFormModal = ({
    visible,
    onClose = NOOP,
    onSave = NOOP,
    initValues = {},
    disable = false,
    hideFields = [],
    disabledFields = []
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [formValues, setFormValues] = useState({});

    const onInnerClose = useCallback(() => {
        setFormValues(prev => ({}));
        setIsLoading(false);
        onClose();
    }, [onClose, setFormValues]);

    const [providers = [], isLoadingProviders] = useRequest(
        "/api/providers/info",
        "POST",
        {
            projection: {
                provider: ["providerId", "businessName", "imageUrl", "isVoucherProvider"],
                product: ["brandName", "engBrandName", "productKosherType"]
            },
            filterOptions: {
                product: {
                    isBidProduct: true
                }
            }
        },
        [visible],
        !!visible,
        (fetchedProviders = []) =>
            fetchedProviders
                ?.filter(provider => !provider.isVoucherProvider)
                ?.map(provider => {
                    const bidProduct = provider?.services?.[0];
                    return {
                        ...provider,
                        brandName: bidProduct?.brandName ?? bidProduct?.engBrandName ?? provider?.businessName,
                        productKosherType: kosherTypesToHebrew[bidProduct?.productKosherType]
                    };
                }) ?? []
    );

    const onFormUpdate = useCallback(
        (_, changedField) => {
            const [key, value] = Object.entries(changedField)[0];
            setFormValues(currentFormValues => set({...currentFormValues}, key, value));
        },
        [setFormValues]
    );

    const onFinish = useCallback(async () => {
        setIsLoading(true);
        await onSave({
            ...formValues,
            ...(formValues.maxPrice ? {maxPrice: Number(formValues.maxPrice)} : {}),
            ...(formValues.floor ? {floor: Number(formValues.floor)} : {}),
            ...(formValues.participantsAmount ? {participantsAmount: Number(formValues.participantsAmount)} : {})
        });
        setIsLoading(false);
    }, [formValues, onSave]);

    useEffect(() => {
        if (!isEmpty(initValues)) {
            setFormValues(initValues);
        }
    }, [initValues]);

    return (
        <ConfigProvider direction="rtl">
            <FormModal
                content={formValues}
                className="brief-form-modal"
                confirmButtonTitle="שליחת בריף"
                header="בניית בריף להצעת מחיר מותאמת"
                subTitle={briefModalDescription}
                visible={visible}
                onUpdate={onFormUpdate}
                modalWidth="40%"
                isConfirmButtonLoading={isLoading}
                onSave={onFinish}
                fields={buildBriefFormFields(
                    providers,
                    formValues?.address,
                    onFormUpdate,
                    disable,
                    disabledFields,
                    hideFields,
                    BriefMainServices,
                    isLoadingProviders
                )}
                onClose={onInnerClose}
                disableAll={disable}
            />
        </ConfigProvider>
    );
};
